import { render, staticRenderFns } from "./setLastName.vue?vue&type=template&id=84873b2a&scoped=true&"
import script from "./setLastName.vue?vue&type=script&lang=js&"
export * from "./setLastName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84873b2a",
  null
  
)

export default component.exports